import type { AdStartedParam } from '../../../types/global';

export type ClickTracker = {
  adId: string;
  creativeId: string;
  clickTrackingUrl: string;
};

export const getClickTrackingUrls = (xml: XMLDocument) => {
  const trackers: ClickTracker[] = [];

  xml.querySelectorAll('Ad').forEach((ad) => {
    ad.querySelectorAll('Creative').forEach((creative) => {
      creative.querySelectorAll('ClickTracking').forEach((node) => {
        const clickTrackingUrl = node.textContent;

        if (clickTrackingUrl) {
          trackers.push({
            adId: ad.id,
            creativeId: creative.id,
            clickTrackingUrl,
          });
        }
      });
    });
  });

  return trackers;
};

export const findClickTrackingUrls = (
  adMeta: AdStartedParam['meta'],
  clickTrackers: ClickTracker[]
) => {
  if (adMeta.wrapperAdIds) {
    return adMeta.wrapperAdIds
      .map((adId) => {
        const trackers = clickTrackers.filter(
          (tracker) => tracker.adId === adId
        );

        if (trackers.length === 1) {
          return trackers[0];
        }

        return undefined;
      })
      .filter((tracker): tracker is ClickTracker => Boolean(tracker));
  }

  const tracker = clickTrackers.find(({ adId, creativeId }) => {
    return adId === adMeta.adId && creativeId === adMeta.creativeId;
  });

  return tracker ? [tracker] : [];
};

export const firePixelTracker = (url: string) => {
  const image = new Image();
  image.src = url;
};
